import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";

const ViewLoadingAdvise = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [clientsList, setClientsList] = useState([]);
  const [returnsClient, setreturnsClient] = useState("");
  const [returnsClientCode, setReturnsClientCode] = useState("");
  const [returnsProduct, setReturnsProduct] = useState("");
  const [returnsProductCode, setReturnsProductCode] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [returnsQty, setReturnsQty] = useState("");
  const [returnsPoNo, setReturnsPoNo] = useState("");

  const [adviceNo, setAdviceNo] = useState("");
  const [adviceDate, setAdviceDate] = useState(new Date().toISOString());
  const [routeFrom, setRouteFrom] = useState("");
  const [routeTo, setRouteTo] = useState("");
  const [routeId, setRouteId] = useState("");
  const [uom, setUom] = useState("");
  const [mill, setMill] = useState("");
  const [routeList, setRoutList] = useState([]);
  const [millsList, setMillsList] = useState([]);

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "VEHICLE TYPE",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1096`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setAdviceNo(response?.data[0]?.NEWID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    //   Route's List

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=524`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRoutList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Route Details:", error);
      });

    // Client's List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=599`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        //    "CLIENTCODE": "2",
        // "CLIENTNAME": "WESTERN REGION",
        setClientsList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Client Details:", error);
      });

    //   Items List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=625`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item.OM_ITEM_FINISHED_RAW_MATERIAL === "F"
        );
        setProductsList(filter);
        //    "OM_ITEM_FINISHED_RAW_MATERIAL": "F",
        // "ITEMCODE": "8",
        // "MAINNAME": "Dunia Home Baking",
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    //   Mills List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=295`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setMillsList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filterData = response?.data?.filter(
          (item) => item.VEHICLESTATE === "SENT TO LOAD"
        );

        setisloading(false);
        setVehiclesList(filterData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  // Saving
  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1097`,
        {
          OT_LOADING_ADVISE_NO: Number(adviceNo),
          OT_LOADING_ADVISE_DATE: moment(adviceDate).format("YYYY/MM/DD"),
          OT_LOADING_ADVISE_ROUTE_NO: routeId,
          OT_LOADING_ADVISE_VEHICLE_NO: vehicleNo,
          OT_LOADING_ADVISE_CLIENT_CODE: returnsClientCode
            ? returnsClientCode
            : "",
          OT_LOADING_ADVISE_PRODUCT_CODE: returnsProductCode
            ? returnsProductCode
            : "",
          OT_LOADING_ADVISE_PRODUCT_QTY: returnsQty ? Number(returnsQty) : 0,
          OT_LOADING_ADVISE_CLIENT_PO_NO: returnsPoNo ? Number(returnsPoNo) : 0,
          OT_LOADING_ADVISE_PRODUCT_UOM: uom,
          OT_LOADING_ADVISE_FROM_MILL: mill,
          OT_LOADING_ADVISE_PROCESSED_BY: user,
          OT_LOADING_ADVISE_PROCESSED_DATE: moment(date).format("YYYY/MM/DD"),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Loading Advice Saved successfully`);
        console.log(`Loading Advice Saved successfully`);
        await SaveVehicleState();
      } else {
        setisloading(false);
        console.error(`Error while saving Loading Advice`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Loading Advice`, error);
    }
  }

  async function SaveVehicleState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: "SEND TO DISPATCH",
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "SENT TO LOAD",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
    }
  }

  const handleRowClick = (value, index) => {
    setVehicleNo(value["VEHICLE REG NO"]);
    // fetchLastGateInNo(value?.OT_VEHICLE_REG_NO);
    setShowGateIn(true);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen p-4">
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          View Loading Advise
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE TYPE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE TYPE"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                    ? "NO"
                    : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[300px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="lg:text-3xl font-bold flex lg:justify-center justify-start">
            LOADING ADVICE
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Advice No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={adviceNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">Advice Date:</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={adviceDate?.split("T")[0]}
              onChange={(e) => setAdviceDate(e.target.value)}
            ></input>

            <p className="text-red-600 lg:ml-2">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2">Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-6 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2">Route From:</p>
            <Select
              className="lg:w-48 w-64 lg:ml-2"
              value={
                routeFrom
                  ? { value: routeFrom, label: routeFrom }
                  : { value: "", label: "Select  From" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setRouteFrom(e.value);
                  if (routeTo !== "") {
                    const compliance = routeList.find(
                      (item) =>
                        item.ROUTEFROM === e.value && item.ROUTETO === routeTo
                    );
                    setRouteId(compliance?.ROUTEID);
                  }
                } else {
                  setRouteFrom("");
                }
              }}
              options={[
                { value: "", label: "Select From  Route" },
                ...routeList?.map((item) => ({
                  value: item.ROUTEFROM,
                  label: item.ROUTEFROM,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-2">Route To:</p>
            <Select
              className="lg:w-48 w-64 lg:ml-2"
              value={
                routeTo
                  ? { value: routeTo, label: routeTo }
                  : { value: "", label: "Select  To Route" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setRouteTo(e.value);
                  if (routeFrom !== "") {
                    const route = routeList.find(
                      (item) =>
                        item.ROUTEFROM === routeFrom && item.ROUTETO === e.value
                    );
                    setRouteId(route?.ROUTEID);
                  }
                } else {
                  setRouteFrom("");
                }
              }}
              options={[
                { value: "", label: "Select To  Route" },
                ...routeList?.map((item) => ({
                  value: item.ROUTETO,
                  label: item.ROUTETO,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-6">Route Id:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={routeId}
              readOnly
            ></input>
          </div>

          {/* Row 3 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Client Name :</p>
            <Select
              className="w-64 lg:ml-2"
              value={
                returnsClient
                  ? { value: returnsClient, label: returnsClient }
                  : { value: "", label: "Select Client" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setreturnsClient(e.value);
                  const compliance = clientsList.find(
                    (item) => item.CLIENTNAME === e.value
                  );
                  setReturnsClientCode(compliance?.CLIENTCODE);
                } else {
                  setreturnsClient("");
                }
              }}
              options={[
                { value: "", label: "Select Client" },
                ...clientsList?.map((item) => ({
                  value: item.CLIENTNAME,
                  label: item.CLIENTNAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-8">Product :</p>
            <Select
              className="w-64 lg:ml-2"
              value={
                returnsProduct
                  ? { value: returnsProduct, label: returnsProduct }
                  : { value: "", label: "Select Product" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setReturnsProduct(e.value);
                  const compliance = productsList.find(
                    (item) => item.MAINNAME === e.value
                  );
                  setReturnsProductCode(compliance?.ITEMCODE);
                } else {
                  setReturnsProduct("");
                }
              }}
              options={[
                { value: "", label: "Select Product" },
                ...productsList?.map((item) => ({
                  value: item.MAINNAME,
                  label: item.MAINNAME,
                })),
              ]}
            ></Select>
          </div>

          {/* Row 4 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Quanity:</p>
            <input
              className="w-20 h-8 border border-black lg:ml-11 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={returnsQty}
              onChange={(e) => setReturnsQty(e.target.value)}
            ></input>

            <p className="text-red-600 lg:ml-2">PO No:</p>
            <input
              className="w-20 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={returnsPoNo}
              onChange={(e) => setReturnsPoNo(e.target.value)}
            ></input>

            <p className="text-red-600 lg:ml-2">UOM:</p>
            <input
              className="w-20 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={uom}
              onChange={(e) => setUom(e.target.value)}
            ></input>
            <p className="text-red-600 lg:ml-8">Mill :</p>
            <Select
              className="w-64 lg:ml-2"
              value={
                mill
                  ? { value: mill, label: mill }
                  : { value: "", label: "Select Mill" }
              }
              onChange={(e) => {
                setMill(e.value);
              }}
              options={[
                { value: "", label: "Select Mill" },
                ...millsList?.map((item) => ({
                  value: item.MILLNO,
                  label: item.MILLNO,
                })),
              ]}
            ></Select>
          </div>

          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (!adviceDate) {
                  alert("Kindly Supply Advice Date");
                  return;
                } else if (!routeId) {
                  alert("Kindly Supply Route details");
                  return;
                } else if (!returnsClientCode) {
                  alert("Kindly Supply Client");
                  return;
                } else if (!returnsProductCode) {
                  alert("Kindly Supply Product");
                  return;
                } else if (!returnsQty) {
                  alert("Kindly Supply Quantity");
                  return;
                } else if (!returnsPoNo) {
                  alert("Kindly Supply PO NO");
                  return;
                } else if (!uom) {
                  alert("Kindly Supply UOM");
                  return;
                } else if (!mill) {
                  alert("Kindly Supply Mill");
                  return;
                } else {
                  await SaveGateIn();
                  setShowGateIn(false);
                  window.location.reload();
                }
              }}
            >
              PROCEED LOADING ADVISE
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default ViewLoadingAdvise;
